<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="选择用户：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请选择用户">
              <el-button slot="append" @click="userOpenBtn">查询</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="商品：" prop="goodsSpecSubmitSaveDtoList">
            <el-button @click="goodsOpenBtn">添加商品</el-button>
            <el-table
              v-if="multipleSelectionSure.length > 0"
              style="margin-top: 16px;width: 476px;"
              border
              :data="multipleSelectionSure">
              <el-table-column
                align="center"
                prop="apiGoodsName"
                label="商品名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="apiSpecName"
                label="规格">
              </el-table-column>
              <el-table-column
                align="center"
                prop="apiSpecPrice"
                label="商品价格">
              </el-table-column>
              <el-table-column
                align="center"
                prop="goodsSpecNumber"
                width="120"
                label="数量">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.goodsSpecNumber" @change="goodsInputChange()" style="width: 96px;" controls-position="right" :min="1"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作">
                <template slot-scope="scope">
                  <span @click="goodsDelBtn(scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="配送方式：" prop="deliveryType">
            <el-radio-group v-model="ruleForm.deliveryType" @change="typeChangeBtn">
              <el-radio :label="0">快递配送</el-radio>
              <el-radio :label="1">自提</el-radio>
              <el-radio :label="2">同城配送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.deliveryType === 0 || ruleForm.deliveryType == 2" label="收货地址：" prop="userAddressId">
            <div>
              <el-button @click="addressOpenBtn">选择地址</el-button>
            </div>
            <div v-if="ruleForm.userAddressId != ''" class="mt-entrymodel-single" style="padding-left: 0;margin-top: 8px;">
              <div class="mt-entrymodel-single-info">
                <div class="mt-entrymodel-single-address">{{addressRowSure.address+addressRowSure.detail}}</div>
                <div class="flex-row-align">
                  <div class="mt-entrymodel-single-name">{{addressRowSure.realName}}</div>
                  <div class="mt-entrymodel-single-name">{{addressRowSure.phone}}</div>
                </div>
              </div>
            </div>
            
          </el-form-item>
          <!-- <el-form-item label="优惠券：" prop="couponReceiveId">
            <div @click.stop="couponOpenBtn">
              <el-input readonly style="width: 424px;" v-model="couponName" placeholder="请选择优惠券" suffix-icon="el-icon-arrow-right"></el-input>
            </div>
          </el-form-item> -->
          <el-form-item label="备注：" prop="remark">
            <el-input style="width: 424px;" v-model="ruleForm.remark" placeholder="请输入订单备注"></el-input>
          </el-form-item>
          <el-form-item label="订单信息：" prop="name">
            <div class="mt-order-info">
              <div class="mt-order-info-row">订单金额 <span>￥{{orderMoney}}</span></div>
              <div class="mt-order-info-row">商品折扣 <span>-￥{{discountGoodsMoney}}</span></div>
              <div class="mt-order-info-row">会员折扣 <span>-￥{{discountMoney}}</span></div>
              <div class="mt-order-info-row">订单运费 <span>￥{{(isFreeMove == 0 && ruleForm.deliveryType === 0) || (isFreeMove == 0 && ruleForm.deliveryType ===  3) ? moveMoney : 0}}</span></div>
            </div>
          </el-form-item>
          <el-form-item label="支付：" prop="name">
            <el-radio-group v-model="isSelected">
              <el-radio :label="1">余额支付（￥{{sureMoney}}）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="支付金额：" prop="name">
            ¥ {{payTotal}}
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">确认录入</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsShow"
      width="960px">
      <el-form :model="searchForm" inline ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商品名称：" prop="name">
          <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        :data="infoList"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsSpecId"
          label="ID">
        </el-table-column>
        <el-table-column
          align="center"
          prop="thumb"
          label="商品图">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.thumb"
              :preview-src-list="[scope.row.thumb]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="apiGoodsName"
          label="商品名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="apiSpecName"
          label="商品规格">
        </el-table-column>
        <el-table-column
          align="center"
          prop="apiSpecPrice"
          label="商品价格">
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="goodsSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
    <!-- 选择用户弹窗 -->
    <el-dialog
      title="选择用户"
      :visible.sync="userShow"
      width="960px">
      <el-form :model="ruleForm" inline ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户信息：" prop="name">
          <el-input class="mt-search-width" v-model="ruleForm.name" placeholder="请输入手机号/眠称搜索用户"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchUserBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="mt-entrymodel-scroll">
        <div class="mt-entrymodel-single" v-for="(item,index) in userList" :key="index" @click="userChooseBtn(item.userId,item.nickName,item.money,item)">
          <img class="mt-entrymodel-single-icon" :src="userId == item.userId ? imgServer+'choosed_icon.png' : imgServer+'choose_icon.png'" alt="" />
          <div class="mt-entrymodel-single-info">
            <div class="flex-row-align">
              <div class="mt-entrymodel-single-name">{{item.nickName}}</div>
              <div class="mt-entrymodel-single-name">{{item.phone}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="userSureBtn()">确认选择</el-button>
      </div>
    </el-dialog>
    <!-- 选择地址弹窗 -->
    <el-dialog
      title="选择地址"
      :visible.sync="addressShow"
      width="960px">
      <div class="mt-entrymodel-scroll">
        <div class="mt-entrymodel-single" v-for="(item,index) in addressList" :key="index" @click="addressChooseBtn(item.id,item)">
          <img class="mt-entrymodel-single-icon" :src="addressId == item.id ? imgServer+'choosed_icon.png' : imgServer+'choose_icon.png'" alt="" />
          <div class="mt-entrymodel-single-info">
            <div class="mt-entrymodel-single-address">{{item.address+item.detail}}</div>
            <div class="flex-row-align">
              <div class="mt-entrymodel-single-name">{{item.realName}}</div>
              <div class="mt-entrymodel-single-name">{{item.phone}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="addressSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
    <!-- 选择优惠券弹窗 -->
    <el-dialog
      title="选择优惠券"
      :visible.sync="couponShow"
      width="960px">
      <div class="mt-entrymodel-scroll">
        <div class="mt-entrymodel-single" v-for="(item,index) in couponList" :key="index" @click="couponChooseBtn(item.id,item)">
          <img class="mt-entrymodel-single-icon" :src="couponId == item.id ? imgServer+'choosed_icon.png' : imgServer+'choose_icon.png'" alt="" />
          <div class="mt-entrymodel-single-info">
            <div class="mt-entrymodel-single-address">{{item.couponName}}</div>
            <div class="flex-row-align">
              <div class="mt-entrymodel-single-name">面额:￥{{item.couponMoney}} {{ item.couponMoneyDesc }}</div>
              <div class="mt-entrymodel-single-name">有效期 {{item.expireTime}}</div>
            </div>
            <div class="mt-entrymodel-single-warm">{{item.useRule}}</div>
          </div>
        </div>
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="couponSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchUserShopList, queryUserCouponReceiveLogList, getOrderInputMoveMoney,querySelectShopGoodsPageList,queryUserAddressList,submitOrderInput } from '@/api/order'
export default {
  name: 'Banner_add',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      ruleForm: {
        userId:'',
        deliveryType: 0,
        userAddressId:'',
        couponReceiveId:'',
        goodsSpecSubmitSaveDtoList:[],
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请选择用户', trigger: 'blur' }
        ],
        goodsSpecSubmitSaveDtoList: [
          { required: true, message: '请添加商品', trigger: 'blur' }
        ],
        deliveryType: [
          { required: true, message: '请选择配送方式', trigger: 'blur' }
        ],
        userAddressId: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ]
      },
      // 选择用户
      userShow:false,
      loading: false,
      userList:[],
      userId:'',
      userName:'',
      money:'0.00',
      sureMoney:'0.00',
      userRow:{
        createTime: "",
        discountRate: "",
        levelId: "",
        money: "",
        nickName: "",
        phone: "",
        updateTime: "",
        userId: ""
      },
      userSureRow:{
        createTime: "",
        discountRate: "",
        levelId: "",
        money: "",
        nickName: "",
        phone: "",
        updateTime: "",
        userId: ""
      },
      // 选择优惠券-注意：管理端订单录入-优惠券不做种类或其他限制判断，选了就能直接用 废弃
      couponShow:false,
      couponList:[],
      couponEmpty:false,
      couponId:'',
      couponName:'',
      couponRow:{
        couponMoney:"",
        couponName:"",
        createTime:"",
        expireTime:"",
        id:"",
        updateTime:"",
        useRule:""
      },
      couponSureRow:{
        couponMoney:"",
        couponName:"",
        createTime:"",
        expireTime:"",
        id:"",
        updateTime:"",
        useRule:""
      },
      // 选择地址
      addressShow:false,
      addressId:'',
      addressRow:{
        createTime: "",
        address: "",
        detail: "",
        realName: "",
        phone: "",
        isDefault: ""
      },
      addressRowSure:{
        createTime: "",
        address: "",
        detail: "",
        realName: "",
        phone: "",
        isDefault: ""
      },
      addressList:[],
      addressEmpty:false,
      // 选择商品弹窗
      searchForm: {
        name:''
      },
      goodsShow:false,
      multipleSelection: [],
      multipleSelectionSure: [],
      pageTotal: 0,
      currentPage: 1,
      limitLength: this.$limitLength,
      infoList:[],
      // 获取订单录入运费
      isFreeMove:1,
      moveMoney:0,
      // 选中余额支付
      isSelected:1,
      // 订单信息
      payTotal:0,
      orderMoney:0,
      discountMoney:0,
      discountGoodsMoney:0
    }
  },
  mounted () {
    
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 选择用户弹窗-打开操作
    userOpenBtn(){
      this.userShow = true;
      this.userInfoFun();
    },
    // 选择用户弹窗-搜索操作
    searchUserBtn(){
      this.userInfoFun();
    },
    // 选择用户弹窗-选择操作
    userChooseBtn(id,name,money,item){
      this.userId = id;
      this.userName = name;
      this.money = money;
      this.userRow = item;
    },
    // 选择用户弹窗-确认选择操作
    userSureBtn(){
      this.ruleForm.userId = this.userId;
      this.ruleForm.name = this.userName;
      this.sureMoney = this.money;
      this.userSureRow = this.userRow;
      this.userShow = false;
    },
    // 选择用户弹窗-数据
    userInfoFun(){
      let that = this
      that.loading = true
      searchUserShopList({ searchStr: that.ruleForm.name }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.userList = data
          that.loading = false
        }
        if (res.errorCode === '4002') {
          that.userList = []
          that.loading = false
        }
      })
    },
    // 获取选择优惠券数据-打开操作
    couponOpenBtn(){
      this.couponInfoFun();
      this.couponShow = true;
    },
    // 获取选择优惠券数据-选择优惠券操作
    couponChooseBtn(id,row){
      this.couponId = id;
      this.couponRow = row;
    },
     // 获取选择优惠券数据-确认选择优惠券操作
    couponSureBtn(id,row){
      this.ruleForm.couponReceiveId = this.couponId;
      this.couponSureRow = this.couponRow;
      this.couponName = '- ¥'+this.couponRow.couponMoney;
      this.couponShow = false;
    },
    // 获取选择优惠券数据
    couponInfoFun(){
      let that = this
      queryUserCouponReceiveLogList({ userId: that.ruleForm.userId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.couponList = data
          that.couponEmpty = false
        }
        if (res.errorCode === '4002') {
          that.couponList = []
          that.couponEmpty = true
        }
      })
    },
    // 获取收货地址数据-打开操作
    addressOpenBtn(){
      this.addressInfoFun();
      this.addressShow = true;
    },
    // 获取收货地址数据-选择操作
    addressChooseBtn(id,row){
      this.addressId = id;
      this.addressRow = row;
    },
    // 获取收货地址数据-确认选择操作
    addressSureBtn(){
      this.ruleForm.userAddressId = this.addressId;
      this.addressRowSure = this.addressRow;
      this.addressShow = false;
      this.moveMoneyInfoFun();
    },
    // 获取收货地址数据
    addressInfoFun(){
      let that = this
      queryUserAddressList({ userId: that.ruleForm.userId,type:that.ruleForm.deliveryType === 0 ? 1 : 2 }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.addressList = data
          that.addressEmpty = false
        }
        if (res.errorCode === '4002') {
          that.addressList = []
          that.addressEmpty = true
        }
      })
    },
    // 配送方式切换
    typeChangeBtn(){
      if(this.ruleForm.deliveryType === 1){
        return false;
      }
      this.moveMoneyInfoFun();
    },
     // 获取订单录入运费
    moveMoneyInfoFun(){
      let that = this
      let multipleSelectionSure = that.multipleSelectionSure;
      let goodsOrderList = [];
      multipleSelectionSure.forEach(function(item){
        goodsOrderList.push({goodsSpecId:item.goodsSpecId,goodsSpecNumber:item.goodsSpecNumber})
      })
      let passData = {
        userAddressId:that.ruleForm.userAddressId,
        goodsSpecSubmitSaveDtoList:goodsOrderList
      }
      getOrderInputMoveMoney(passData).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.isFreeMove = data.isFreeMove
          that.moveMoney = data.moveMoney
          that.totalFun()
        }
        if (res.errorCode === '4002') {
          that.isFreeMove = 0
          that.moveMoney = 0
        }
      })
    },
    // 选择商品弹窗-table操作
    getRowKeys(row) {
      return row.goodsSpecId
      // 需要return的是一个唯一的标识值
    },
    // 选择商品弹窗-打开弹窗
    goodsOpenBtn(){
      this.getInfoList();
      this.goodsShow = true;
    },
    // 选择商品弹窗-实时监听商品的更改数量
    goodsInputChange(){
      this.ruleForm.goodsSpecSubmitSaveDtoList = [1];
      this.totalFun()
    },
    // 选择商品弹窗-删除已选择的商品
    goodsDelBtn(index){
      this.multipleSelectionSure.splice(index,1);
      this.multipleSelection = this.multipleSelectionSure;
      this.totalFun()
    },
    /* 选择商品弹窗-搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 选择商品弹窗-选择商品操作
    handleSelectionChange(val) {
      // console.log(val,'val')
      this.multipleSelection = val;
    },
    // 选择商品弹窗-确认选择
    goodsSureBtn(){
      var multipleSelection = this.multipleSelection;
      if(multipleSelection.length == 0){
        this.$message.error('请选择商品');
        return false;
      }
      this.multipleSelectionSure = multipleSelection;
      this.goodsShow = false;
      this.totalFun()
    },
    // 计算订单金额、商品折扣、会员折扣、支付金额（注意：管理端订单录入-优惠券不做种类或其他限制判断，选了就能直接用）
    totalFun(){
      let that = this
      let deliveryType = that.ruleForm.deliveryType;
      let isFreeMove = that.isFreeMove;
      let moveMoney = that.moveMoney;
      let discountRate = that.userSureRow.discountRate == 0 ? 1 : that.userSureRow.discountRate;
      let discountMoney = 0;
      let discountGoodsMoney = 0;
      let total = 0;
      let orderMoney = 0;
      let multipleSelectionSure = that.multipleSelectionSure;
      multipleSelectionSure.forEach(function(item){
        let priceSingle = parseFloat(item.apiSpecPrice);
        let numSingle = parseInt(item.goodsSpecNumber);
        let numSingleOld = parseInt(item.goodsSpecNumber); // 如果有商品折扣且满足商品折扣条件用来计算超出条件的商品数量用原价计算价格
        let discountRateSingle = 1;
        let discountActivityDiscountRateSingle = 1;
        let overNumPrice = 0; // overNumPrice参与商品折扣超出数量的商品原价计算的单品价格（如果有会员折扣的话，超出的数量也不能参与会员折扣）

        // 注意普通商品有商品折扣就不能使用优惠券和会员折扣（例满2件9折，买的是3件或者是4件，商品折扣都只能计算两件的商品折扣，超出的按原价计算，也不能使用优惠券和会员折扣）；是会员折扣可以使用优惠券
        if(item.goodsSpecNumber >= item.discountActivityNumber && item.discountActivityNumber > 0){
          // item.discountActivityNumber 小于或等于0都是不参与商品折扣的意思
          // 参与商品折扣
          var limitNum = parseInt(item.discountActivityNumber);
          numSingle = parseInt(item.discountActivityNumber);
          overNumPrice = parseFloat(parseFloat(numSingleOld - limitNum) * priceSingle);
          discountActivityDiscountRateSingle = parseFloat(item.discountActivityDiscountRate);
          discountGoodsMoney = parseFloat(parseFloat(discountGoodsMoney) + parseFloat((priceSingle * limitNum) - priceSingle * limitNum * discountActivityDiscountRateSingle)).toFixed(2);
        }else{
          // 不参与商品折扣
          discountActivityDiscountRateSingle = 1;
          if(item.enableDiscount == 1){
            // 参与会员折扣
            discountRateSingle = parseFloat(discountRate);
            discountMoney = parseFloat(parseFloat(discountMoney) + parseFloat((priceSingle * numSingle) - (priceSingle * numSingle * discountRateSingle))).toFixed(2);
          }else{
            // 不参与会员折扣
            discountRateSingle = 1;
          }
        }
        total = parseFloat(total + that.goodsPriceFun(priceSingle,numSingle,discountRateSingle,discountActivityDiscountRateSingle) + overNumPrice);
        // 订单金额（不含运费）
        orderMoney = parseFloat(orderMoney + numSingle * priceSingle);
      })
      var totalIsMove = total;
      if(isFreeMove == 0 && deliveryType === 0){
        // 快速配送情况下不免运费
        totalIsMove = parseFloat(total) + parseFloat(moveMoney);
      }else if(isFreeMove == 0 && deliveryType === 3){
        // 同城配送情况下不免运费
        totalIsMove = parseFloat(total) + parseFloat(moveMoney);
      }
      total = totalIsMove;
      that.payTotal = total.toFixed(2);
      that.orderMoney = orderMoney.toFixed(2);
      that.discountMoney = discountMoney;
      that.discountGoodsMoney = discountGoodsMoney;
    },
    // 单个商品计算
    goodsPriceFun(price,num,discountRate,discountActivityDiscountRate){
      var singleTotal = 0;
      singleTotal = parseFloat(num*price*discountRate*discountActivityDiscountRate);
      return singleTotal;
    },
    // 选择商品弹窗-获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      querySelectShopGoodsPageList({ goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
            item.goodsSpecNumber = 1;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 选择商品弹窗-当前页码操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 保存操作
    saveBtn () {
      let that = this
      let deliveryType = that.ruleForm.deliveryType
      let remark = that.ruleForm.remark
      let userAddressId = that.ruleForm.userAddressId
      let couponReceiveId = that.ruleForm.couponReceiveId
      let userId = that.ruleForm.userId
      let multipleSelectionSure = that.multipleSelectionSure
      let goodsOrderList = []
      multipleSelectionSure.forEach(function(item){
        goodsOrderList.push({goodsSpecId:item.goodsSpecId,goodsSpecNumber:item.goodsSpecNumber})
      })
      if (userId === '') {
        this.$message.error('请选择用户')
        return false
      }
      if (goodsOrderList.length === 0) {
        this.$message.error('请添加商品')
        return false
      }
      if (userAddressId === '' && deliveryType != 1) {
        this.$message.error('请选择收货地址')
        return false
      }
      let passData = {
        deliveryType:deliveryType,
        remark:remark,
        userAddressId:userAddressId,
        userId:userId,
        goodsOrderList:goodsOrderList
      }
      submitOrderInput(passData).then((res) => {
        that.backDataFun(res)
      })
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderEntry.vue